// Texto para el usuario de un error del API de Obras.
//
// El API responde { message } en todos sus errores de negocio. Si no llega (sesión
// caducada, sin conexión, tiempo agotado, validación de ASP.NET con ProblemDetails o un
// error del servidor web), antes se enseñaba un texto genérico que no decía qué había
// pasado. Ahora se dice la causa y, si no se conoce, el código HTTP para diagnosticar.
export function apiErrorMessage(err, fallback) {
    const response = err?.response;
    const data = response?.data;
    if (data && typeof data === "object") {
        if (typeof data.message === "string" && data.message.trim()) return data.message.trim();
        // ProblemDetails de validación: { title, errors: { campo: ["mensaje"] } }.
        const firstError = data.errors && typeof data.errors === "object"
            ? Object.values(data.errors).flat().find((text) => typeof text === "string" && text.trim())
            : null;
        if (firstError) return `${fallback} ${firstError.trim()}`;
    }
    if (!response) {
        if (err?.code === "ECONNABORTED") return `${fallback} El servidor tardó demasiado en responder.`;
        return `${fallback} No hay conexión con el servidor.`;
    }
    switch (response.status) {
        case 401: return "La sesión ha caducado. Vuelve a iniciar sesión y repite el cambio.";
        case 403: return "No tienes permiso para hacer este cambio.";
        case 404: return `${fallback} El elemento ya no existe (puede que alguien lo haya borrado).`;
        default: return `${fallback} (error ${response.status})`;
    }
}
